<template>
    <div class="animated fadeIn">
        <h3>{{Core.Definition.getDefinition("Votre achat a bien été effectué avec succès. Merci!")}}</h3>
        <p>
            {{Core.Definition.getDefinition("Si vous avez des questions, des commentaires ou des préoccupations, n'hésitez pas à nous contacter. Notre équipe se tient à votre disposition pour vous assister de toutes les manières possibles!")}}
        </p>
    </div>
</template>

<script>
    import Request from '../../../components/Request'
    import Form from '../../../components/CForm'
    import Cart from '../../../components/Cart'
    import InputCC from '../../../components/InputCC'
    export default {
        name: 'ShopThankYou',
        components: {
            Cart,
            InputCC,
            Request,
            Form
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        methods: {
        }
    }
</script>
